import styled from '@emotion/styled';
import type { FC } from 'react';

import Badge from '../../Badge';
import Tooltip from '../../Tooltip';
import type { BadgeGroupCellProps, BadgeItem } from '../types';

const BadgeGroupRoot = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  minWidth: 0,
  overflow: 'hidden',
  flexWrap: 'nowrap',
});

const buildOverflowTitle = (hidden: BadgeItem[]) => hidden.map((b) => b.label).join(', ');

export const BadgeGroupCell: FC<BadgeGroupCellProps> = ({ badges, maxVisible }) => {
  // Guard against unmapped statuses producing undefined badge entries.
  const safeBadges = (badges ?? []).filter((b): b is BadgeItem => Boolean(b));
  const visible = maxVisible !== undefined ? safeBadges.slice(0, maxVisible) : safeBadges;
  const hidden = maxVisible !== undefined ? safeBadges.slice(maxVisible) : [];
  const overflowCount = hidden.length;

  return (
    <BadgeGroupRoot>
      {visible.map((badge) => (
        <Tooltip key={badge.label} title={badge.tooltip} disabled={!badge.tooltip}>
          <div>
            <Badge label={badge.label} color={badge.color ?? 'default'} variant="subtle" />
          </div>
        </Tooltip>
      ))}
      {overflowCount > 0 && (
        <Tooltip title={buildOverflowTitle(hidden)}>
          <div>
            <Badge label={`+${overflowCount}`} color="default" variant="subtle" />
          </div>
        </Tooltip>
      )}
    </BadgeGroupRoot>
  );
};

BadgeGroupCell.displayName = 'BadgeGroupCell';
